import React from 'react';
import parse from 'html-react-parser';

interface SafeHTMLRendererProps {
    html: string;
    className?: string;
    maxLength?: number
}

const SafeHTMLRenderer: React.FC<SafeHTMLRendererProps> = ({
    html,
    className,
    maxLength
}) => {
    const cleanHtml = (rawHtml: string) => {
        let cleaned = rawHtml.replace(/<script.*?>.*?<\/script>/gi, '');
        const textContent = cleaned.replace(/<[^>]+>/g, '');
        if (!maxLength || textContent.length <= maxLength) {
            return cleaned.replace(/\n/g, '<br />');
        }

        let visibleLength = 0;
        let resultHtml = '';
        let insideTag = false;
        let tagBuffer = '';

        for (let i = 0; i < cleaned.length; i++) {
            const char = cleaned[i];

            if (char === '<') {
                insideTag = true;
                tagBuffer = char;
                continue;
            }

            if (insideTag) {
                tagBuffer += char;
                if (char === '>') {
                    insideTag = false;
                    resultHtml += tagBuffer;
                    tagBuffer = '';
                }
                continue;
            }

            if (visibleLength < maxLength) {
                resultHtml += char;
                visibleLength++;
            } else {
                break;
            }
        }

        // Добавляем многоточие, если текст был обрезан
        if (visibleLength >= maxLength) {
            resultHtml += '...';
        }

        return resultHtml.replace(/\n/g, '<br />');
    };

    return (
        <span className={className}>
            {parse(cleanHtml(html))}
        </span>
    );
};

export default SafeHTMLRenderer;